import { useState } from "react";
import { postManualRecommendation } from "../lib/api";
import { getUserInfo } from "../lib/auth";
import { useDocumentTitle } from "../hooks/use-document-title";

export function ManualRecommendPage() {
  useDocumentTitle("Recommend Vehicle");
  const user = getUserInfo();
  const [userId, setUserId] = useState("");
  const [vehicleId, setVehicleId] = useState("");
  const [senderName, setSenderName] = useState(
    user ? `${user.givenName} ${user.familyName}` : "",
  );
  const [customMessage, setCustomMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setResult(null);

    const parsedUserId = Number(userId);
    const parsedVehicleId = Number(vehicleId);

    if (!Number.isFinite(parsedUserId) || parsedUserId <= 0) {
      setResult("Invalid user ID");
      return;
    }
    if (!Number.isFinite(parsedVehicleId) || parsedVehicleId <= 0) {
      setResult("Invalid vehicle ID");
      return;
    }
    if (!customMessage.trim()) {
      setResult("Please enter a message");
      return;
    }

    setSending(true);
    try {
      await postManualRecommendation({
        userId: parsedUserId,
        vehicleId: parsedVehicleId,
        senderName: senderName.trim() || "Otto",
        senderPhotoUrl: null,
        customMessage: customMessage.trim(),
      });
      setResult("Recommendation sent successfully");
      setUserId("");
      setVehicleId("");
      setCustomMessage("");
    } catch (err: unknown) {
      setResult(
        `Failed: ${err instanceof Error ? err.message : "Unknown error"}`,
      );
    } finally {
      setSending(false);
    }
  }

  return (
    <>
      <h1 className="page-title">Push Vehicle Recommendation</h1>

      <div className="card" style={{ maxWidth: 500 }}>
        <form onSubmit={(e) => void handleSubmit(e)}>
          <div className="form-group">
            <label>Dealer User ID</label>
            <input
              type="number"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="e.g. 1234"
            />
          </div>

          <div className="form-group">
            <label>Vehicle Project ID</label>
            <input
              type="number"
              value={vehicleId}
              onChange={(e) => setVehicleId(e.target.value)}
              placeholder="e.g. 5678"
            />
          </div>

          <div className="form-group">
            <label>Your Name (shown to dealer)</label>
            <input
              type="text"
              value={senderName}
              onChange={(e) => setSenderName(e.target.value)}
              placeholder="e.g. John Smith"
            />
          </div>

          <div className="form-group">
            <label>Custom Message</label>
            <textarea
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
              placeholder="e.g. Great match for your stock profile — low mileage, strong margin potential."
            />
          </div>

          <button
            className="btn btn-primary"
            type="submit"
            disabled={sending}
          >
            {sending ? "Sending..." : "Send Recommendation"}
          </button>
        </form>

        {result && (
          <div
            style={{ marginTop: 12 }}
            className={
              result.startsWith("Failed") ? "error-msg" : "badge badge-success"
            }
          >
            {result}
          </div>
        )}
      </div>
    </>
  );
}
